import { Button, Stack } from "@mui/material";
import { inputBaseClasses } from "@mui/material/InputBase";
import { useTranslation } from "@privacy/translations";

export type TextFieldActionButtonsProps = {
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
  isEditing: boolean;
  isDirty: boolean;
};

export const TextFieldActionButtons = ({
  onSave,
  onCancel,
  isSaving,
  isDirty,
  isEditing,
}: TextFieldActionButtonsProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        pt: 2,
        gap: 2,
        width: "100%",
        justifyContent: "flex-end",
        visibility: isEditing ? "visible" : "hidden",
      }}
    >
      <Button
        tabIndex={isDirty ? 0 : -1}
        onClick={e => {
          e.stopPropagation();
          onCancel();
        }}
        size="small"
        variant="outlined"
      >
        {t("TextFieldActionButtons.Cancel")}
      </Button>
      <Button
        tabIndex={isDirty ? 0 : -1}
        onClick={e => {
          e.stopPropagation();
          isDirty ? onSave() : onCancel();
        }}
        loading={isSaving}
        size="small"
        type="submit"
      >
        {t("TextFieldActionButtons.Save")}
      </Button>
    </Stack>
  );
};

TextFieldActionButtons.TextFieldSx = {
  [`& .${inputBaseClasses.root}`]: { display: "flex", flexDirection: "column", px: 2 },
};

TextFieldActionButtons.onTextFieldWrapperBlur = ({ isDirty, onCancel }: { isDirty: boolean; onCancel: () => void }) => {
  return (e: React.FocusEvent) => {
    const next = e.relatedTarget;
    if (e.currentTarget.contains(next)) return;
    if (!isDirty) onCancel();
  };
};
